module.exports = __webpack_public_path__ + "assets/images/alerts-actions.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/alerts-actions/alerts-actions.png
// module id = NY2E
// module chunks = 1